import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface NoteDialogState {
  isVisible: boolean;
  currentScenario: {
    scenario_id?: number;
    name?: string;
    note_text?: string;
    note_user?: string;
    note_updated_at?: string;
    note_pk_id?: number | null;
    [key: string]: any;
  } | null;
}

const initialState: NoteDialogState = {
  isVisible: false,
  currentScenario: null
};

const noteDialogSlice = createSlice({
  name: 'noteDialog',
  initialState,
  reducers: {
    openNoteDialog: (state, action: PayloadAction<{ [key: string]: any }>) => {
      state.isVisible = true;
      state.currentScenario = action.payload;
    },
    closeNoteDialog: (state) => {
      state.isVisible = false;
    },
    toggleNoteDialog: (state, action: PayloadAction<{
      visibility: boolean;
      scenario: { [key: string]: any };
    }>) => {
      
      state.isVisible = action.payload.visibility;
      state.currentScenario = action.payload.scenario;
    },
    updateNoteInState: (state, action: PayloadAction<{
      scenario_id: number;
      note_text: string;
      note_user: string;
      note_updated_at: string;
      note_pk_id?: number;
    }>) => {
      
      if (state.currentScenario && state.currentScenario.scenario_id === action.payload.scenario_id) {
        console.log(action.payload);
        state.currentScenario.note_text = action.payload.note_text;
        state.currentScenario.note_user = action.payload.note_user;
        state.currentScenario.note_updated_at = action.payload.note_updated_at;
        state.currentScenario.note_pk_id = action.payload.note_pk_id;
        
      }
    },
  },
});

export const { 
  openNoteDialog, 
  closeNoteDialog, 
  toggleNoteDialog, 
  updateNoteInState 
} = noteDialogSlice.actions;

export default noteDialogSlice;